var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleextrakeys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M8 4C5.801 4 4 5.801 4 8v9c0 2.198 1.801 4 4 4h9c2.199 0 4-1.802 4-4V8c0-2.199-1.801-4-4-4zm0 2h9c1.125 0 2 .875 2 2v7c0 1.126-.875 2-2 2H8c-1.125 0-2-.874-2-2V8c0-1.125.875-2 2-2z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.914 13.725H11.09L10.646 15H8.83l2.593-7h2.152l2.593 7h-1.815l-.44-1.275zm-2.373-1.3h1.918l-.957-2.784-.96 2.785z",
    fontWeight: 700,
    fontSize: 10,
    fontFamily: "DejaVu Sans",
    letterSpacing: 0,
    wordSpacing: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleextrakeys);
export default __webpack_public_path__ + "static/media/toggleextrakeys.44548bf16e2ced60531cf7f187eb52c3.svg";
export { ForwardRef as ReactComponent };